import * as swcHelpers from '@swc/helpers';
import { mapProductProjectionToListingProduct } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import { useAsyncState, isDefined } from '@grandvisionhq/utils';
import { queryAlgolia } from '../utils/query-algolia.js';

function useAlgoliaSearch(algoliaConfig, searchOptions) {
    const intl = useIntl();
    const { result: result1  } = useAsyncState({
        result: [],
        hasError: false,
        isLoading: true
    }, swcHelpers.asyncToGenerator(function*() {
        const result = yield queryAlgolia(algoliaConfig, searchOptions);
        if (result === null) {
            console.error(`[useAlgoliaSearch]: Something went wrong searching Algolia.`);
            return {
                result: [],
                hasError: true,
                isLoading: false
            };
        }
        const mappedResult = result.hits.map((product)=>mapProductProjectionToListingProduct(product, intl)
        ).filter(isDefined);
        return {
            result: mappedResult,
            hasError: false,
            isLoading: false
        };
    }), [
        searchOptions,
        algoliaConfig
    ]);
    return result1;
}

export { useAlgoliaSearch };
//# sourceMappingURL=use-algolia-search.js.map
